import { isGlobalAdmin } from "@/helpers/permissions/users";

export function isAdminOfCommunity(user, community) {
  if (!community) {
    return false;
  }

  return !!(user?.community_user_roles || []).find(
    (r) => r.community_id === community.id && r.role === "admin"
  );
}

export function isManagerOfCommunity(user, community) {
  if (!community) {
    return false;
  }

  return !!(user?.community_user_roles || []).find(
    (r) => r.community_id === community.id && r.role === "manager"
  );
}

export function isObserverOfCommunity(user, community) {
  if (!community) {
    return false;
  }

  return !!(user?.community_user_roles || []).find(
    (r) => r.community_id === community.id && r.role === "observer"
  );
}

export function getAdminCommunities(user) {
  return (user?.community_user_roles || [])
    .filter((r) => r.role === "admin")
    .map((r) => r.community);
}

export function getCommunityAdminAreaCommunities(user) {
  return (user?.community_user_roles || [])
    .filter((r) => ["admin", "manager", "observer"].includes(r.role))
    .map((r) => r.community);
}

export function getCommunityAdminFilter(user, action, key = "communities.id") {
  if (isGlobalAdmin(user)) {
    return {};
  }

  const communitiesWithRole = getCommunityAdminAreaCommunities(user);
  switch (action) {
    case "read":
    default:
      return {
        [key]: [...communitiesWithRole.map((c) => c.id), 0].join(","),
      };
  }
}

export function isAdminOfSomeCommunity(user) {
  return getCommunityAdminAreaCommunities(user).length > 0;
}

export function canSeeDeletedCommunity(user) {
  return isGlobalAdmin(user);
}

export function canManageCommunityRoles(user, community) {
  return (
    isGlobalAdmin(user) ||
    isAdminOfCommunity(user, community) ||
    isManagerOfCommunity(user, community)
  );
}

export function canViewCommunityAdminData(user, community) {
  return (
    isGlobalAdmin(user) ||
    isAdminOfCommunity(user, community) ||
    isManagerOfCommunity(user, community) ||
    isObserverOfCommunity(user, community)
  );
}

export function canManageCommunityAdminData(user, community) {
  return (
    isGlobalAdmin(user) ||
    isAdminOfCommunity(user, community) ||
    isManagerOfCommunity(user, community)
  );
}
